import { IPaginatedParams, PageInfo } from '../../share-types'

export enum VersionItemTypeEnums {
  CHARGE = 'Charge',
  BILLING = 'Billing',
  BILLING_TRANSACTION = 'BillingTransaction',
  BILLING_ADJUSTMENT = 'BillingAdjustment',
  BOOKING = 'Booking',
  LESSON = 'Lesson',
  SUBSCRIPTION = 'Subscription',
  REFERRAL = 'Referral',
  USER = 'User',
  TERM_BOOKING_COUNT = 'TermBookingCount',
  PLAN = 'Plan',
}

export interface IVersion {
  id: number
  itemId: number
  itemType: string
  action: string
  eventName?: string
  snapshot?: string
  changes: string
  who: string
  createdAt?: string
}

export interface PaginatedVersionsResponse {
  pageInfo: PageInfo
  data: IVersion[]
}

export interface IVersionFilterParams {
  itemType?: VersionItemTypeEnums
  itemId?: number
  eventName?: string
  createdAtFrom?: string
  createdAtTo?: string
}

export type IPaginatedVersionsParams = IPaginatedParams & IVersionFilterParams
